export enum ColumnConfigKey {
    IsinCusip = 'IsinCusip',
    Ticker = 'Ticker',
    Inventory = 'Inventory',
    Asset = 'Asset',
    Currency = 'Currency',
    Rating = 'Rating',
    BidSize = 'BidSize',
    Size = 'Size',
    AddOn = 'AddOn',
    PxTalk = 'PxTalk',
    PxTalkDm = 'PxTalkDm',
    Color = 'Color',
    ColorDm = 'ColorDm',
    ColorWal = 'ColorWal',
    DealName = 'DealName',
    CollateralManager = 'CollateralManager',
    ClosingDate = 'ClosingDate',
    PricingDate = 'PricingDate',
    NcEndYrs = 'NcEndYrs',
    RiEndYrs = 'RiEndYrs',
    NcEnd = 'NcEnd',
    OutOfNc = 'OutOfNc',
    RiEnd = 'RiEnd',
    OutOfRi = 'OutOfRi',
    Maturity = 'Maturity',
    Vintage = 'Vintage',
    Trustee = 'Trustee',
    AmrDeal = 'AmrDeal',
    StaticDeal = 'StaticDeal',
    EuCompliance = 'EuCompliance',
    Esg = 'Esg',
    CollateralType = 'CollateralType',
    Actions = 'Actions',
    LastUpdateDate = 'LastUpdateDate',
    Dealer = 'Dealer',
    Bid = 'Bid',
    Offer = 'Offer',
    CreditEnhancement = 'CreditEnhancement',
    BidDmBps = 'BidDmBps',
    OfferDmBps = 'OfferDmBps',
    OfferYield = 'OfferYield',
    Coupon = 'Coupon',
    CurrentCoupon = 'CurrentCoupon',
    WalYears = 'WalYears',
    Mvoc = 'Mvoc',
    Description = 'Description',
    Bwic = 'Bwic',
    CurrentBwic = 'CurrentBwic',
    LastTraded = 'LastTraded',
    EvalPriceTalk = 'KTalk',
    KTalkDm = 'KTalkDm',
    DealDocuments = 'DealDocuments',
    ImTransaction = 'ImTransaction',
    ArrangerPipeline = 'ArrangerPipeline',
    RollerDeadline = 'RollerDeadline',
    CleansingNotice = 'CleansingNotice',

    LastUpdated = 'LastUpdated',
    IssuerName = 'IssuerName',
    Status = 'Status',
    Review = 'Review',
    AnalystUserId = 'AnalystUserId',
    ArrangerReferenceName = 'ArrangerReferenceName',
    CoArrangers = 'CoArrangers',
    Contacts = 'Contacts',
    DueDate = 'DueDate',
    LenderCallDate = 'LenderCallDate',
    Dataroom = 'Dataroom',
    Facility = 'Facility',
    CurrencyCode = 'CurrencyCode',
    CovLite = 'CovLite',
    IssuerDescription = 'IssuerDescription',
    Industry = 'Industry',
    UseOfProceeds = 'UseOfProceeds',
    CallProtection = 'CallProtection',
    InitialGuidance = 'InitialGuidance',
    Guidance = 'Guidance',
    GuidanceChange = 'GuidanceChange',
    Price = 'Price',
    Floor = 'Floor',
    Margin = 'Margin',
    RefIndex = 'RefIndex',
    TrancheRating = 'TrancheRating',
    CFRating = 'CFRating',
    TermYears = 'TermYears',
    Order = 'Order',
    Target = 'Target',
    Allocation = 'Allocation',
    AllocationPct = 'AllocationPct',
}
